import { Trans } from 'react-i18next'
import AlreadyRegisteredWrapper from 'app/auth/components/onboarding/steps/shared/AlreadyRegisteredWrapper'
import { Box, Typography } from '@mui/material'
import { Link } from '@carsys/ui'
import { useApplicationName } from 'hooks/use-application-name'
import { useOnboardingContext } from '../../use-onboarding-context'

const GenericDuplicationError: React.FC = () => {
  const { duplicationData } = useOnboardingContext()
  const { appName } = useApplicationName()

  return (
    <AlreadyRegisteredWrapper>
      <Box my={2}>
        <Typography component='div' variant='body1' style={{ whiteSpace: 'pre-line' }}>
          <Trans
            i18nKey='Auth.Onboarding.DuplicateGenericMessageTag' // optional -> fallbacks to defaults if not provided
            // eslint-disable-next-line max-len
            defaults='Welcome! A {{appName}} account already exists for this {{shopNumber}} shop. \n\nPlease visit <linkto>{{domain}}</linkto> and login with your credentials, or start the password reset procedure. \n\nIf this does not work, please contact our support team.'
            values={{ appName, shopNumber: duplicationData?.dupe.ID, domain: location.origin }}
            components={{ linkto: <Link to='/' /> }}
          />
        </Typography>
      </Box>
    </AlreadyRegisteredWrapper>
  )
}

export default GenericDuplicationError
